<template>
  <li
    :style="anchorStyle"
    class="reaction-anchor relative flex h-7 items-center justify-center cursor-pointer rounded-16 bg-bg-base-bg6"
    :class="{
      'bg-surf-brand-base-def!': reactionData.isSetByCurrentUser,
      'bg-comp-messages-emojiitems-bg-out!': !incoming && !reactionData.isSetByCurrentUser,
      'pr-2': reactionData.authors.size > 1,
    }"
    data-test="reactionButton"
    @mouseenter="onMouseEnterActivator"
    @mouseleave="onMouseLeaveActivator"
    @click="emitReaction(emoji, reactionData.isSetByCurrentUser)"
  >
    <p
      :class="[reactionData.isSetByCurrentUser ? 'text-surf-lock-wht' : 'text-fg-base-fg3', emoji.length > 2 ? 'text-label-r-12-18 ml-1' : 'text-emoji-r-18-18']"
      class="flex justify-center items-center text-nowrap pl-1"
    >
      {{ emoji }}
    </p>
    <p
      v-if="reactionData.authors.size > 1"
      class="text-label-sb-12-18 ml-1"
      :class="reactionData.isSetByCurrentUser ? 'text-surf-lock-wht' : 'text-fg-base-fg22'"
    >
      {{ reactionData.authors.size }}
    </p>
    <contact-avatar
      v-else-if="reactionData.authors.size === 1"
      :size="24"
      :contact="contact"
      class="m-px ml-0.5"
    />
    <div
      v-if="hover && isShowReactionInfo && reactionData.authors.size > 1"
      class="reaction-popup z-20"
      @mouseleave="onMouseLeavePopup"
    >
      <reaction-info
        :reaction-data="reactionData"
        :emoji="emoji"
        class="relative z-20"
      />
    </div>
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue'


import { useStoreContacts } from '@/entities/contact'
import { ContactAvatar } from '@/entities/contact-avatar'
import { ReactionInfo, ReactionData, Emoji } from '@/entities/reaction'

import { useCurrentUser } from '@/shared/composables/current-user'
import { useHover } from '@/shared/composables/use-hover'
import { EmittedReaction } from '@/shared/types/emitted-reaction'

const { currentUser } = useCurrentUser()

const props = defineProps<{
  reactionData: ReactionData,
  emoji: Emoji
  incoming?: boolean,
  isShowReactionInfo: boolean
}>()

const emit = defineEmits<{
  (event: 'toggleReaction', payload: EmittedReaction): void
}>()

const contact = computed(() => {
  const author = Array.from(props.reactionData.authors)[0] as string
  if (author === currentUser.value?.imLogin) return currentUser.value
  return useStoreContacts().findByPServed(author)
})

const { hover, show, hide } = useHover()

const emitReaction = (emoji: string, isSetByCurrentUser: boolean) => {
  emit('toggleReaction', { emoji, isSetByCurrentUser })
}

const anchorName = `--reaction-${Math.random().toString(36).slice(2, 9)}`
const anchorStyle = {
  '--reaction-anchor-name': anchorName,
} as Record<string, string>


const onMouseEnterActivator = () => {
  show()
}

const onMouseLeavePopup = () => {
  hide()
}

const onMouseLeaveActivator = () => {
  hide()
}
</script>

<style scoped>
.border-color-gray {
  border-color: rgba(186, 199, 219, 0.9) !important
}

.reaction-anchor {
  anchor-name: var(--reaction-anchor-name);
}

.reaction-popup {
  position: fixed;
  position-anchor: var(--reaction-anchor-name);
  bottom: anchor(top);
  left: anchor(center);
  transform: translate(-30%, 0);
  margin-bottom: 2px;
}
</style>
